import {database} from '../main'
export const getProgramsMixin = {
  data () {
    return {
      programs: []
    };
  },
  methods: {
    getPrograms (id) {
      database.ref(`contracts/${id}/programs`).on('value', async programs => {
        programs = programs.val()
        let programIds = programs ? Object.keys(programs) : []
        programs = programIds.map(async (id) => {
          const program = await database.ref(`programs/${id}`).once('value')
          return {...program.val(), id: program.key}
        })
        const programArray = await Promise.all(programs)
        this.programs = programArray
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/getProgramsMixin.js